<template>
    <v-dialog v-model="mostrar" persistent max-width="70vw" scrollable>
		<v-card>
			<v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
			<v-divider></v-divider>
            <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="12">
                        <v-text-field label="Nome" v-model="publicacao.nome" outlined></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-select item-text="text" 
                                    item-value="value" 
                                    :items="graus" 
                                    v-model="publicacao.grau" 
                                    label="Grau" 
                                    outlined>
                        </v-select>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field label="Autor" v-model="publicacao.autor" outlined></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-select item-text="text" 
                                    item-value="value" 
                                    :items="categorias" 
                                    v-model="publicacao.categoria" 
                                    label="Categoria" 
                                    outlined>
                        </v-select>
                    </v-col>
                    <v-col cols="12">
                        <VueEditor v-model="publicacao.conteudo" placeholder="Informe o Conteúdo da publicação..." />
                    </v-col>
                </v-row>
            </v-container>
            </v-card-text>
            <v-card-actions>
				<v-spacer></v-spacer>
                <v-checkbox class="mt-5" 
                            v-model="rascunho" 
                            label="Salvar como rascunho">
                </v-checkbox>
				<v-btn text color="primary" @click.stop="salvar()">Salvar</v-btn>
				<v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
			</v-card-actions>
		</v-card>
    </v-dialog>    
</template>

<script>
import Br from '@/config/barramento.js'
import metodos from '@/mixins/metodos'
import {VueEditor} from "vue2-editor"

// import { mapState } from 'vuex'
import { baseApiUrl, showError, showSuccess } from "@/config/global"
import axios from 'axios'


export default {
    name: 'categoria',
    mixins: [metodos],
    props:['mostrar'],
    components:{
        VueEditor
    },
    data(){
        return{
            cor: 'primary',
            publicacao: {},
            categorias: [],
            rascunho: null,
        }
    },
    computed:{
        graus(){
				let arr = []
				for( let i = 1; i <= this.$store.state.user.outros.grauAtual; i++){
					arr[i - 1] = {value: i.toString(), text: i.toString()}
				}
				return arr;
			}
    },
    methods:{
        mostrarDados(){
            
        },
        salvar(){
            const url = `${baseApiUrl}/estudos/insert.php`
            this.publicacao.iniciado = this.$store.state.user.iniciado

            if(this.publicacao.nome && this.publicacao.autor && this.publicacao.categoria && this.publicacao.grau && this.publicacao.conteudo){

                if(!this.publicacao.rascunho){
                    this.publicacao.rascunho = 'P'
                }
                axios.post(url, this.publicacao)
                .then(res => {

                    if(res.data.codigo == '01'){
                        
                        this.publicacao.id = res.data.id_publicacao
                        this.publicacao.data_publicacao = this.mostrarData(this.converterData(res.data.data_publicacao))
                        Br.setPublicacaoCadastrada(this.publicacao)

                        showSuccess('Publicação salva com sucesso')
    
                        if(this.publicacao.rascunho != 'C'){
                            
                            const urlEmail = `${baseApiUrl}/emails/novaPublicacao.php`
                            axios.post(urlEmail, {titulo: this.publicacao.nome, data_publicacao: this.publicacao.data_publicacao, iniciado: this.$store.state.user.dados.nome}).then(res => {
                                
                            })
                        }

                        this.fechar()
                    }else{
                        showError(res.data.mensagem)
                    }
                    
                })	
            }else{
                showError("Todos os campos devem ser preenchidosssss!")
            }	
        },

        fechar(){
            this.$emit('update:mostrar', false)
        },

        buscaCategorias(){
            const url = `${baseApiUrl}/Cadastros/categorias/read.php`

            axios(url).then(res => {
                if(res.data.dados){
                    this.categorias = res.data.dados.map( c =>{
                        return {
                            value: c.id, text: c.descricao
                        }
                    })

                    this.mostrar = true
                }
            })
        }
    },

    watch:{
        rascunho(val){
            if(val){
                this.publicacao.rascunho = "C"
                this.publicacao.status = "rascunho"
            }else{
                this.publicacao.rascunho = "P"
                this.publicacao.status = "pendente"
            }
        },

        mostrar(val){
            if(val){
                this.publicacao = {}
                this.buscaCategorias()
            }
        }
    }
}
</script>

<style scoped>

</style>